<template>
    <div class="wrapper-content w-100">
        <div class="no-search-found position-relative text-center">
            <img v-if="!icon" src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
            <div v-else class="wrap-circle">
                <font-awesome-icon :icon="icon" />
            </div>
            <h1 v-text="title ? title : $t('not_found_h1')"></h1>
            <h2 v-text="subtitle ? subtitle : $t('not_found_h2')"></h2>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="sass" scoped>
.no-search-found
  padding: 5%
  flex-grow: 1
  img
    margin: 0 auto 30px auto
    display: block
    @media(max-width: $md)
      max-width: 50%
  h1,
  h2
    color: $primaryFontThemeColor
    max-width: 700px
    margin: 0 auto
    text-align: center
    @media(max-width: $md)
      min-width: 100px
  h1
    font-size: 24px
    margin-bottom: 10px
    @media(max-width: $md)
      font-size: 18px
  h2
    font-size: 18px
    @media(max-width: $md)
      font-size: 14px
  .wrap-circle
    display: flex
    justify-content: center
    align-items: center
    margin: 0 auto
    padding-bottom: 30px
    font-size: 7em
    color: #cccccc
    border-radius: 50%
</style>
